"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../TopBanner/constants");
const BannerSkeleton = exports.BannerSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  width: '100%',
  marginBottom: theme.spacing(3),
  height: _constants.TOP_BANNER_MOBILE_HEIGHT,
  [theme.breakpoints.up('sm')]: {
    height: _constants.TOP_BANNER_DESKTOP_HEIGHT
  }
}));
//# sourceMappingURL=styles.js.map